import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import FullScreenModal from 'components/consumer/FullScreenModal';
import IconMobileGrid1x from 'components/icons/iconMobileGrid1x';
import IconMobileGrid2x from 'components/icons/iconMobileGrid2x';
import ToggleTabGroup from 'components/consumer/ToggleTabGroup';
import Placeholder from 'components/consumer/Placeholder';
import getTabContentId from 'commons/getTabContentId';
import getTabId from 'commons/getTabId';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
import useScreen from 'hooks/useScreen';
import useJumpToSelectedGalleryPhoto from './hooks/useJumpToSelectedGalleryPhoto';
const PDPFullScreenGalleryBodyPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Placeholder loading={true} type="rect" style={{
      width: "100%",
      height: "50vh",
      margin: 0
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const PDPFullScreenGalleryBody = loadable(() => import('./PDPFullScreenGalleryBody'), {
  fallback: <PDPFullScreenGalleryBodyPlaceholder />,
  loading: PDPFullScreenGalleryBodyPlaceholder
});
const PDPFullScreenGallery = t0 => {
  const $ = _c(44);
  const {
    className: t1,
    displayShownIn: t2,
    enableCrops: t3,
    pdpIsModularBYOProduct: t4,
    initialSelectedPhotoIndex: t5,
    isEditOrder: t6,
    isOpen: t7,
    onClose,
    onPhotoViewed,
    photos: t8,
    productName: t9,
    showGridView: t10
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const displayShownIn = t2 === undefined ? false : t2;
  const enableCrops = t3 === undefined ? true : t3;
  const pdpIsModularBYOProduct = t4 === undefined ? false : t4;
  const initialSelectedPhotoIndex = t5 === undefined ? 0 : t5;
  const isEditOrder = t6 === undefined ? false : t6;
  const isOpen = t7 === undefined ? false : t7;
  let t11;
  if ($[0] !== t8) {
    t11 = t8 === undefined ? [] : t8;
    $[0] = t8;
    $[1] = t11;
  } else {
    t11 = $[1];
  }
  const photos = t11;
  const productName = t9 === undefined ? "" : t9;
  const showGridView = t10 === undefined ? false : t10;
  const {
    isMobileOrTablet
  } = useScreen();
  const [mobileColumnsAcross, setMobileColumnsAcross] = useState(1);
  const is2MobileColumns = mobileColumnsAcross === 2;
  const [isPinchGalleryOpen, setIsPinchGalleryOpen] = useState(false);
  const [pinchGalleryIndex, setPinchGalleryIndex] = useState(0);
  const [hasOpened, setHasOpened] = useState(isOpen);
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(initialSelectedPhotoIndex);
  let t12;
  let t13;
  if ($[2] !== initialSelectedPhotoIndex) {
    t12 = () => {
      setSelectedPhotoIndex(initialSelectedPhotoIndex);
    };
    t13 = [initialSelectedPhotoIndex];
    $[2] = initialSelectedPhotoIndex;
    $[3] = t12;
    $[4] = t13;
  } else {
    t12 = $[3];
    t13 = $[4];
  }
  useEffect(t12, t13);
  let t14;
  let t15;
  if ($[5] !== isOpen) {
    t14 = () => {
      if (isOpen) {
        setHasOpened(true);
      }
    };
    t15 = [isOpen];
    $[5] = isOpen;
    $[6] = t14;
    $[7] = t15;
  } else {
    t14 = $[6];
    t15 = $[7];
  }
  useEffect(t14, t15);
  let t16;
  if ($[8] !== isOpen || $[9] !== selectedPhotoIndex) {
    t16 = {
      selectedPhotoIndex,
      isOpen
    };
    $[8] = isOpen;
    $[9] = selectedPhotoIndex;
    $[10] = t16;
  } else {
    t16 = $[10];
  }
  const galleryRef = useJumpToSelectedGalleryPhoto(t16);
  const [selectedDesktopTab, setSelectedDesktopTab] = useState("Listed");
  const selectedTab = isMobileOrTablet ? "Listed" : selectedDesktopTab;
  const shouldLoadBody = isOpen || hasOpened;
  let t17;
  if ($[11] !== selectedTab || $[12] !== showGridView) {
    t17 = showGridView ? <ToggleTabGroup selectedTab={getTabId(selectedTab, "PDPFullScreenGallery")} noBottomBorder={true} size="md" aria-label="Full Screen Gallery Grid" items={["Listed", "Grid"].map(label => ({
      id: getTabId(label, "PDPFullScreenGallery"),
      label,
      contentId: getTabContentId(label, "PDPFullScreenGallery"),
      onClick: () => {
        setSelectedDesktopTab(label);
      }
    }))} /> : undefined;
    $[11] = selectedTab;
    $[12] = showGridView;
    $[13] = t17;
  } else {
    t17 = $[13];
  }
  let t18;
  if ($[14] !== productName) {
    t18 = <span className="text-sm font-bold items-center text-gray flex h-full justify-center">{productName}</span>;
    $[14] = productName;
    $[15] = t18;
  } else {
    t18 = $[15];
  }
  let t19;
  if ($[16] !== is2MobileColumns) {
    t19 = <div className="items-center flex h-full" role="button" tabIndex="0" onClick={() => {
      setMobileColumnsAcross(is2MobileColumns ? 1 : 2);
    }}>{is2MobileColumns ? <IconMobileGrid2x /> : <IconMobileGrid1x />}</div>;
    $[16] = is2MobileColumns;
    $[17] = t19;
  } else {
    t19 = $[17];
  }
  let t20;
  if ($[18] !== className || $[19] !== displayShownIn || $[20] !== enableCrops || $[21] !== galleryRef || $[22] !== is2MobileColumns || $[23] !== isEditOrder || $[24] !== isMobileOrTablet || $[25] !== isPinchGalleryOpen || $[26] !== mobileColumnsAcross || $[27] !== onClose || $[28] !== onPhotoViewed || $[29] !== pdpIsModularBYOProduct || $[30] !== photos || $[31] !== pinchGalleryIndex || $[32] !== productName || $[33] !== selectedTab || $[34] !== shouldLoadBody) {
    t20 = shouldLoadBody && <PDPFullScreenGalleryBody className={className} displayShownIn={displayShownIn} enableCrops={enableCrops} galleryRef={galleryRef} is2MobileColumns={is2MobileColumns} isEditOrder={isEditOrder} isMobileOrTablet={isMobileOrTablet} isPinchGalleryOpen={isPinchGalleryOpen} mobileColumnsAcross={mobileColumnsAcross} onClose={onClose} onPhotoViewed={onPhotoViewed} pdpIsModularBYOProduct={pdpIsModularBYOProduct} photos={photos} pinchGalleryIndex={pinchGalleryIndex} productName={productName} selectedTab={selectedTab} setIsPinchGalleryOpen={setIsPinchGalleryOpen} setPinchGalleryIndex={setPinchGalleryIndex} setSelectedDesktopTab={setSelectedDesktopTab} setSelectedPhotoIndex={setSelectedPhotoIndex} />;
    $[18] = className;
    $[19] = displayShownIn;
    $[20] = enableCrops;
    $[21] = galleryRef;
    $[22] = is2MobileColumns;
    $[23] = isEditOrder;
    $[24] = isMobileOrTablet;
    $[25] = isPinchGalleryOpen;
    $[26] = mobileColumnsAcross;
    $[27] = onClose;
    $[28] = onPhotoViewed;
    $[29] = pdpIsModularBYOProduct;
    $[30] = photos;
    $[31] = pinchGalleryIndex;
    $[32] = productName;
    $[33] = selectedTab;
    $[34] = shouldLoadBody;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== isOpen || $[37] !== isPinchGalleryOpen || $[38] !== onClose || $[39] !== t17 || $[40] !== t18 || $[41] !== t19 || $[42] !== t20) {
    t21 = <FullScreenModal isOpen={isOpen} onClose={onClose} headerLeft={t17} mobileNoPadding={true} mobileHeaderCenter={t18} mobileHeaderRight={t19} mobileHeaderNoPointerEvents={isPinchGalleryOpen}>{t20}</FullScreenModal>;
    $[36] = isOpen;
    $[37] = isPinchGalleryOpen;
    $[38] = onClose;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  return t21;
};
PDPFullScreenGallery.propTypes = {
  className: PropTypes.string,
  displayShownIn: PropTypes.bool,
  enableCrops: PropTypes.bool,
  pdpIsModularBYOProduct: PropTypes.bool,
  initialSelectedPhotoIndex: PropTypes.number,
  isEditOrder: PropTypes.bool,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onPhotoViewed: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    src: PropTypes.string
  })),
  productName: PropTypes.string,
  showGridView: PropTypes.bool
};
export default withBrowserOnly(PDPFullScreenGallery);